// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-s_fP","catalogByServiceItem__title":"c-s_fQ"};